var _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopLocationsTableIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 284,
    viewBox: "0 0 484 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#csprguuj6a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.039,
    y: 8.698,
    width: 459.508,
    height: 258.42,
    rx: 16,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.039,
    y: 11.698,
    width: 453.508,
    height: 252.42,
    rx: 13,
    stroke: "#fff",
    strokeWidth: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.481,
    y: 32.804,
    width: 376.896,
    height: 210.207,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE8F9",
    d: "M67.545 110.261h338.768v17.221H67.545zM67.545 141.947h338.768v17.221H67.545zM67.545 173.633h338.768v17.221H67.545zM67.545 205.319h338.768v17.221H67.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M67.545 71.687h338.768v21.354H67.545z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.879,
    y: 79.953,
    width: 45.935,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 174.342,
    y: 79.953,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.879,
    y: 117.15,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 117.15,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230.614,
    y: 117.15,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 277.697,
    y: 117.15,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 324.779,
    y: 117.15,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 371.863,
    y: 117.15,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77.879,
    y: 148.835,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 148.836,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 230.614,
    y: 148.836,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 277.697,
    y: 148.836,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 324.779,
    y: 148.836,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 371.863,
    y: 148.836,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 77.88,
    y: 180.522,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 180.522,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 230.614,
    y: 180.522,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 277.697,
    y: 180.522,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 324.779,
    y: 180.522,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 371.863,
    y: 180.522,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 77.88,
    y: 212.208,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 212.208,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 230.614,
    y: 212.208,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 277.697,
    y: 212.208,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 324.779,
    y: 212.208,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 371.863,
    y: 212.208,
    width: 12.058,
    height: 2.755,
    rx: 1.378,
    fill: "#909090"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 221.426,
    y: 79.953,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 268.51,
    y: 79.953,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 315.592,
    y: 79.953,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 362.676,
    y: 79.953,
    width: 30.432,
    height: 2.755,
    rx: 1.378,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 215.811,
    y: 64.544,
    width: 42.236,
    height: 163.42,
    rx: 4,
    fill: "#FDDA5F",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.749 59.254v-8.512H70.64v-1.288h7.574v1.288h-3.108v8.512h-1.358zm7.356-6.972c.653 0 1.245.158 1.777.476.542.308.966.737 1.274 1.288.318.541.476 1.143.476 1.806a3.48 3.48 0 0 1-.476 1.792c-.308.541-.732.97-1.274 1.288a3.484 3.484 0 0 1-1.778.462 3.56 3.56 0 0 1-1.791-.462 3.55 3.55 0 0 1-1.288-1.288 3.56 3.56 0 0 1-.463-1.792c0-.663.154-1.265.463-1.806.317-.551.741-.98 1.273-1.288a3.504 3.504 0 0 1 1.806-.476zm-2.297 3.57c0 .429.103.821.308 1.176a2.279 2.279 0 0 0 1.988 1.134c.411 0 .794-.103 1.148-.308.355-.206.635-.481.84-.826.206-.355.308-.747.308-1.176 0-.43-.102-.822-.308-1.176a2.238 2.238 0 0 0-.84-.854 2.252 2.252 0 0 0-1.147-.308c-.42 0-.808.102-1.163.308-.345.205-.62.49-.825.854a2.304 2.304 0 0 0-.309 1.176zm10.88-2.338c-.626 0-1.153.191-1.583.574-.43.382-.676.877-.742 1.484v.532c.066.606.313 1.101.742 1.484.43.382.957.574 1.582.574a2.305 2.305 0 0 0 2.016-1.148c.206-.355.308-.747.308-1.176a2.304 2.304 0 0 0-1.148-2.016 2.304 2.304 0 0 0-1.176-.308zm-3.627-1.092h1.302v1.372a2.737 2.737 0 0 1 1.036-1.12c.448-.262.966-.392 1.554-.392.607 0 1.162.158 1.666.476.514.317.915.751 1.204 1.302a3.62 3.62 0 0 1 .448 1.778c0 .644-.15 1.241-.448 1.792-.29.541-.69.97-1.204 1.288a3.065 3.065 0 0 1-1.666.476c-.588 0-1.106-.131-1.554-.392a2.738 2.738 0 0 1-1.036-1.12v3.85h-1.302v-9.31zm13.323-2.968v8.512h4.816v1.288h-6.174v-9.8h1.358zm8.969 2.828c.653 0 1.246.158 1.778.476.541.308.966.737 1.274 1.288.317.541.476 1.143.476 1.806 0 .653-.159 1.25-.476 1.792-.308.541-.733.97-1.274 1.288a3.485 3.485 0 0 1-1.778.462 3.557 3.557 0 0 1-1.792-.462 3.544 3.544 0 0 1-1.288-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806.317-.551.742-.98 1.274-1.288a3.503 3.503 0 0 1 1.806-.476zm-2.296 3.57c0 .429.102.821.308 1.176a2.277 2.277 0 0 0 1.988 1.134c.41 0 .793-.103 1.148-.308.354-.206.634-.481.84-.826.205-.355.308-.747.308-1.176 0-.43-.103-.822-.308-1.176a2.247 2.247 0 0 0-.84-.854 2.255 2.255 0 0 0-1.148-.308c-.42 0-.808.102-1.162.308-.346.205-.621.49-.826.854a2.298 2.298 0 0 0-.308 1.176zm10.252 3.542c-.653 0-1.25-.154-1.792-.462a3.592 3.592 0 0 1-1.274-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806a3.45 3.45 0 0 1 1.274-1.288 3.48 3.48 0 0 1 1.792-.476c.523 0 1.018.107 1.484.322.467.214.85.513 1.148.896.308.382.5.807.574 1.274h-1.316c-.093-.364-.322-.663-.686-.896a2.08 2.08 0 0 0-1.204-.364c-.42 0-.802.102-1.148.308-.345.205-.62.485-.826.84a2.418 2.418 0 0 0-.294 1.19c0 .429.098.821.294 1.176.206.345.481.62.826.826.346.205.728.308 1.148.308.458 0 .864-.122 1.218-.364.364-.252.593-.57.686-.952h1.302a2.67 2.67 0 0 1-.56 1.316 3.162 3.162 0 0 1-1.148.91 3.54 3.54 0 0 1-1.498.322zm11.338-.14h-1.288v-1.4a2.783 2.783 0 0 1-1.05 1.148c-.438.261-.956.392-1.554.392a3.138 3.138 0 0 1-1.68-.476 3.48 3.48 0 0 1-1.204-1.288 3.798 3.798 0 0 1-.434-1.792c0-.644.145-1.237.434-1.778.299-.551.7-.985 1.204-1.302a3.137 3.137 0 0 1 1.68-.476c.598 0 1.116.135 1.554.406.448.261.798.639 1.05 1.134v-1.4h1.288v6.832zm-5.95-3.416c0 .429.103.821.308 1.176.206.354.486.634.84.84.355.205.747.308 1.176.308.439 0 .836-.098 1.19-.294a2.14 2.14 0 0 0 .84-.84c.206-.355.308-.752.308-1.19 0-.439-.102-.836-.308-1.19a2.046 2.046 0 0 0-.84-.826 2.328 2.328 0 0 0-1.19-.308 2.306 2.306 0 0 0-2.016 1.148 2.308 2.308 0 0 0-.308 1.176zm10.755 3.5c-.737 0-1.321-.215-1.75-.644-.429-.43-.644-1.05-.644-1.862v-3.178h-1.33v-1.232h1.33v-1.848h1.288v1.848h1.848v1.232h-1.848v3.15c0 .457.121.793.364 1.008.243.205.579.308 1.008.308.196 0 .355-.019.476-.056v1.19a2.85 2.85 0 0 1-.742.084zm3.378-6.916v6.832h-1.302v-6.832h1.302zm-.644-1.33a.869.869 0 0 1-.616-.252.869.869 0 0 1-.252-.616c0-.234.084-.434.252-.602a.845.845 0 0 1 .616-.266c.233 0 .434.088.602.266a.802.802 0 0 1 .266.602.869.869 0 0 1-.252.616.837.837 0 0 1-.616.252zm5.61 1.19c.653 0 1.246.158 1.778.476.541.308.966.737 1.274 1.288.317.541.476 1.143.476 1.806 0 .653-.159 1.25-.476 1.792-.308.541-.733.97-1.274 1.288a3.485 3.485 0 0 1-1.778.462 3.56 3.56 0 0 1-1.792-.462 3.551 3.551 0 0 1-1.288-1.288 3.56 3.56 0 0 1-.462-1.792c0-.663.154-1.265.462-1.806.317-.551.742-.98 1.274-1.288a3.503 3.503 0 0 1 1.806-.476zm-2.296 3.57c0 .429.103.821.308 1.176a2.28 2.28 0 0 0 1.988 1.134c.411 0 .793-.103 1.148-.308.355-.206.635-.481.84-.826.205-.355.308-.747.308-1.176 0-.43-.103-.822-.308-1.176a2.233 2.233 0 0 0-.84-.854 2.252 2.252 0 0 0-1.148-.308c-.42 0-.807.102-1.162.308a2.27 2.27 0 0 0-.826.854 2.308 2.308 0 0 0-.308 1.176zm8.541-2.198a2.402 2.402 0 0 1 2.212-1.372c.877 0 1.572.275 2.086.826.513.55.77 1.297.77 2.24v3.906h-1.302v-3.766c0-.598-.168-1.074-.504-1.428-.336-.364-.784-.546-1.344-.546-.57 0-1.032.182-1.386.546-.346.354-.518.83-.518 1.428h-.014v3.766h-1.288v-6.832h1.288v1.232zm9.254 5.74c-.803 0-1.465-.201-1.988-.602-.523-.402-.817-.948-.882-1.638h1.232c.047.336.215.606.504.812.289.205.649.308 1.078.308.42 0 .756-.089 1.008-.266.261-.178.392-.411.392-.7 0-.336-.14-.574-.42-.714-.28-.14-.709-.266-1.288-.378a9.508 9.508 0 0 1-1.232-.322 1.943 1.943 0 0 1-.798-.546c-.215-.252-.322-.602-.322-1.05 0-.588.229-1.069.686-1.442.457-.383 1.064-.574 1.82-.574.7 0 1.302.186 1.806.56.513.364.812.863.896 1.498h-1.302c-.047-.28-.201-.509-.462-.686-.261-.187-.583-.28-.966-.28-.364 0-.658.074-.882.224-.224.149-.336.35-.336.602 0 .214.07.387.21.518.14.13.313.228.518.294.205.056.499.121.882.196.513.093.933.2 1.26.322.327.112.607.308.84.588.233.28.35.667.35 1.162 0 .401-.117.765-.35 1.092-.224.317-.537.569-.938.756a3.16 3.16 0 0 1-1.316.266z",
    fill: "#8C8C8C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "csprguuj6a",
    x: 0.039,
    y: 0.698,
    width: 483.508,
    height: 282.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_2235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_2235",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLocationsTableIllustration);
export default __webpack_public_path__ + "static/media/top-locations-table-illustration.f5cd9d6534d7a8f52cc3ad90c576d321.svg";
export { ForwardRef as ReactComponent };